module.exports = __webpack_public_path__ + "static/media/loading.35da3781.gif";